module.exports = __webpack_public_path__ + "img/contact_call.ece01b6a.svg";